import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import moment from 'moment';
import { columns } from '../utils';
import { unitResource } from '@/views/insurance/underwritingManage/request';
import { agencyResource } from '@/views/insurance//organizationalManage/request';
import { policyBatchList } from '../request1';
import { customerResource } from '@/views/system/customerManage/request';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
export default {
  data() {
    return {
      time: [],
      form: {
        unitId: undefined,
        agencyId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        batchPolicyNo: '',
        status: undefined,
        customerId: undefined
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns,
      unitList: [],
      customerList: [],
      agencyList: [],
      productList: [],
      applicationList: []
    };
  },
  async created() {
    const res = await unitResource({});
    this.unitList = res;
    await this.onChange();
    const res1 = await customerResource({});
    this.customerList = res1;
    if (res.length == 0) {
      return false;
    }
    let arr = res1.find(item => item.id == Number(sessionStorage.getItem('insuredCustomerId')));
    this.form.customerId = arr ? Number(sessionStorage.getItem('insuredCustomerId')) : res1[0].id;
    sessionStorage.setItem('insuredCustomerId', this.form.customerId);
    await this.customerChange();
    await this.searchFun();
  },
  computed: {
    defaultValue() {
      return [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')];
    }
  },
  methods: {
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    openChangeDate(status) {
      if (status) {
        this.time = [];
      }
    },
    // 导出时间change
    onChangeExportTime(date) {
      if (date.length) {
        let startIsToday = moment(this.time[0]).isSame(moment(), 'days') && moment(this.time[0]).isAfter(moment());
        let endIsToday = moment(this.time[1]).isSame(moment(), 'days') && moment(this.time[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.time[0] = moment();
            this.time[1] = moment();
          } else if (endIsToday) {
            this.time[1] = moment();
          }
        }
      }
    },
    disabledRangeTime(dates, type) {
      let hours = moment().hours(); //0~23
      let minutes = moment().minutes(); //0~59
      let seconds = moment().seconds(); //0~59
      //当日只能选择当前时间之后的时间点
      if (this.time[1] && moment(this.time[1]).date() === moment().date() && type === 'end' || this.time[0] && moment(this.time[0]).date() === moment().date() && type === 'start') {
        console.log(this.range(0, hours), this.range(0, minutes));
        return {
          disabledHours: () => this.range(hours + 1, 24),
          disabledMinutes: () => this.range(minutes + 1, 60),
          disabledSeconds: () => this.range(seconds + 1, 60)
        };
      }
      return {
        disabledHours: () => this.range(23, 23),
        disabledMinutes: () => this.range(59, 59),
        disabledSeconds: () => this.range(59, 59)
      };
    },
    disabledDate(current) {
      return current && moment().endOf('day') < current;
    },
    async searchFun() {
      this.pagination.current = 1;
      await this.getDataFun();
    },
    getDataFun() {
      var _this$time, _this$time2;
      let obj = {};
      obj.unitId = this.form.unitId;
      obj.agencyId = this.form.agencyId;
      obj.applicationId = this.form.applicationId;
      obj.insuranceId = this.form.insuranceId;
      obj.status = this.form.status;
      obj.customerId = this.form.customerId;
      obj.batchPolicyNo = this.form.batchPolicyNo;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = (_this$time = this.time) !== null && _this$time !== void 0 && _this$time[0] ? moment(this.time[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      obj.endAt = (_this$time2 = this.time) !== null && _this$time2 !== void 0 && _this$time2[1] ? moment(this.time[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      policyBatchList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async customerChange() {
      if (!this.form.customerId) {
        this.applicationList = [];
        return false;
      }
      sessionStorage.setItem('insuredCustomerId', this.form.customerId);
      this.form.applicationId = undefined;
      this.applicationList = await applicationResource({
        customerId: this.form.customerId
      });
    },
    async changeApplicationId() {
      this.form.insuranceId = undefined;
      if (this.form.applicationId) {
        this.productList = await insuranceResource({
          applicationId: this.form.applicationId
        });
      } else {
        this.productList = [];
      }
    },
    resetFun() {
      this.time = [];
      this.form.agencyId = undefined;
      this.form.unitId = undefined;
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.batchPolicyNo = '';
      this.form.status = undefined;
    },
    async onChange() {
      this.agencyList = [];
      this.form.agencyId = undefined;
      await this.agencyFun2();
    },
    async agencyFun2() {
      const res = await agencyResource({
        unitId: this.form.unitId
      });
      this.agencyList = res;
    },
    agencyFun() {
      this.form.agencyId = undefined;
      agencyResource({
        unitId: this.form.unitId
      }).then(res => {
        this.agencyList = res;
      });
    },
    agencyChange(val) {
      let arr = this.agencyList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
      if (!this.form.unitId) {
        this.agencyFun();
      }
    }
  }
};